<sd-modal>
  <div class="modal-header">
    <h3>Добавьте свою компанию</h3>
  </div>

  <div class="modal-body">
    <sd-add-company (submit)="modalService.closeActiveModal()"></sd-add-company>
  </div>
</sd-modal>
